"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json"

const winterUnitsService = {
  getWinterUnits: function () {
    return api.get("/WinterUnits", WithToken.headersToken({ params: {} }, configuration.cookieName));
  },

  addUnitWinterUnit: function (options) {
    return api.post(`/WinterUnits`, options, WithToken.headersToken({}, configuration.cookieName));
  },

  deleteUnitWinterUnit: function (options) {
    return api.delete(`/WinterUnits`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default winterUnitsService;
